  <template>
  <div class="w-full">
    <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="
                      w-full
                      p-3
                      font-bold
                      text-xl
                      hover:bg-blue-400
                      mt-1
                      bg-blue-600
                      text-white
                      rounded
                      shadow
                    "
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="
                  flex
                  justify-between
                  p-8
                  text-sm
                  border-t border-gray-300
                  bg-gray-100
                "
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>

    <div v-if="numero">
      <div class="border bg-gray-100 grid justify-items-start"></div>
      <!--  <div class="box-content mx-52 mt-3 font-bold">
        <p
          class="
            text-blue-400
            uppercase
            shadow-xl
            rounded
            text-center
            bg-white
            w-auto
            p-2
            border
          "
        >
          maestro de informes
        </p>
      </div>-->
      <div class="mt-2 w-1/1 flex justify-center">
        <div
          class="dropdown bg-black rounded border w-72 uppercase text-center"
        >
          <span class="text-white text-sm bg-black">{{ mensajes }} </span>
          <div class="dropdown-content">
            <h1></h1>
            <button
              class="w-full text-xs uppercase border"
              @click="mostrar('informedisponible')"
            >
              Informe de disponible
            </button>
            <button
              class="w-full text-xs uppercase border"
              @click="mostrar('informeinventarios')"
            >
              Informe inventarios
            </button>
            <button
              class="w-full text-xs uppercase border"
              @click="mostrar('a')"
            >
              Informe Prueba 1
            </button>
            <button
              class="w-full text-xs uppercase border"
              @click="mostrar('informedisponible')"
            >
              Informe Prueba 1
            </button>
            <h1></h1>
          </div>
        </div>
      </div>
      <div>
        <InformeInventario
          v-if="!informeInventaio"
          class="justify-center flex mt-10"
        ></InformeInventario>
        <informedisponible v-if="!informedisponible"></informedisponible>
        <div class="flex justify-center inline mt-16">
          <img
            v-if="!imagen"
            class="rounded border p-5 bg-white rounded-xl"
            width="300px"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgK8kZR2br3s8sLTzSUjpQpTHtpfR8iCy5v0XgpqU2HDhvtTboQdtnTZN2hxLKIYhjmPg&usqp=CAU"
            alt=""
          />
        </div>
        <h1 class="text-center font-bold text-xl">{{ mensaje }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import InformeInventario from "../components/informes/InformeInventario.vue";
import informedisponible from "../components/informes/Informedisponible.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: { InformeInventario, informedisponible },
  name: "Informes",
  data() {
    return {
      user: "",
      mensaje: "",
      pass: "",
      data: "",
      token: "",
      datoss: [],
      false: false,
      imagen: false,
      nel: true,
      informeInventaio: true,
      informedisponible: true,
      valor: true,
      mensajes: "Seleccione el Informe",
    };
  },

  computed: {
    ...mapState(["numero"]),
    ...mapState("informes", ["informe11"]),
  },

  methods: {
    ...mapMutations(["value0", "value1"]),
    //...mapMutations("informes", ["informe1"]),

    mostrar(informe) {
      switch (informe) {
        case "informeinventarios":
          (this.informeInventaio = false),
            (this.informedisponible = true),
            (this.imagen = true),
            (this.mensaje = "");
          break;

        case "informedisponible":
          (this.informedisponible = this.false), (this.informeInventaio = true);
          this.imagen = true;
          this.mensaje = "";
          break;

        default:
          (this.informedisponible = true),
            (this.informeInventaio = true),
            (this.imagen = false),
            (this.mensaje = "No disponible");
          break;
      }
    },
  },
};
</script>
<style scoped>
hr.new2 {
  border-top: 1px dashed red;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 276px;
  box-shadow: 10px 8px 16px 4px rgba(0, 0, 0, 0.2);
  padding: 5px;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap");

body {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
}

* {
  font-family: "Open Sans", sans-serif;
}
.selector {
  border: 1px solid #e2eded;
  border-color: #eaf1f1 #e4eded #dbe7e7 #e4eded;
}
/*************** */
#country-selector {
  position: relative;
  display: block;
  width: 150;
  height: 21px;
  overflow: visible;
  font-size: 0.75em;
}

#country-selector a:hover {
  display: block;
}

#country-selector * {
  user-select: none;
}

#country-selector input {
  color: #e2eded;
}

#select-button {
  position: relative;
  height: auto;
  padding: 0.5em 1em;
  background-color: #3c3f45;
  cursor: pointer;
  color: #fff;
  font-weight: 300;
  transition: 0.3s all ease-in-out;
}

.label {
  display: none;
}

#chevrons {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 10px;
  padding: 5px 74px;
}
#chevrons svg {
  width: 50%;
  height: 100%;
}

#options-view-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

#selected-value {
  font-size: 1em;
  line-height: 1;
  margin-right: 26px;
}

.option,
.label {
  color: #000;
  font-size: 1em;
  font-weight: 500;
}

#chevrons {
  position: absolute;
  top: 2px;
  right: 0;
  bottom: 0;
  width: 20px;
  padding: 12px 14px;
}

#chevrons svg {
  width: 100%;
  height: 100%;
}

#options-view-button:checked + #select-button #chevrons i {
  color: #000;
}

#options-view-button:checked + #select-button {
  background: #000;
}

.options {
  position: absolute;
  left: 0;

  width: 250px;
}

#options {
  right: 0;
  left: 0;
  width: 298px;
  margin: 0 auto;
  background-color: #fff;
  z-index: 1000;
}

#options::-webkit-scrollbar {
  width: 10px;
}

#options::-webkit-scrollbar-track {
  background: #d0d0ce;
}

#options::-webkit-scrollbar-thumb {
  background: #555;
}

#options::-webkit-scrollbar-thumb:hover {
  background: #000;
}

#options-view-button:checked ~ #options {
  height: 12em;
  overflow-y: scroll;
}

.option {
  position: relative;
  line-height: 1;
  z-index: 2;
  transition: none;
}

#options-view-button:checked ~ #options .option i {
  display: block;
  padding: 12px 0;
  background-color: #fff;
}

#options-view-button:checked ~ #options .label {
  display: block;
  padding: 1em 2em;
}

.label {
  text-decoration: none;
  font-weight: 600;
}

a.label:visited {
  color: #000;
}

.option {
  background: #f3f3f3;
}

.option:hover {
  color: #fff;
  background: #3c3f45;
}

.option:hover a {
  color: #fff;
  transition: none;
}
</style>
